import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ibnorca from "../images/Certificación IBNORCA.jpeg";
import impacta from "../images/Certificación IMPACTA.jpeg";
import icontec from "../images/Certificación ICONTEC.jpg";

import director from "../images/iiifiComponents/Director.png";
import dLino from "../images/iiifiComponents/Inv. Lino.jpg";
import dVelasco from "../images/iiifiComponents/Inv. Velasco.jpg";
import dLuque from "../images/iiifiComponents/Inv. Luque.jpg";
import dDanitza from "../images/iiifiComponents/Inv. Danitza.jpg";
import dTeran from "../images/iiifiComponents/Inv. Terán.jpg";

import mision from "../images/resources/MISIÓN.png";
import vision from "../images/resources/VISIÓN.png";
import politicaCalidad from "../images/resources/POLITICA DE LA CALIDAD 2025.jpeg";

import reseña from "../images/quienesSomos/reseña2.png";
import directorBackground from "../images/quienesSomos/director1.png";

import ImageCard from "../components/ImageCard";
import Divider from "@mui/material/Divider";
import Slider from "react-slick";
import { carouselSettings } from "../utils/Carrousel.config";

import SchoolIcon from "@mui/icons-material/School";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AnimatedSection from "../components/AnimatedSection";

const imagenesCertificaciones = [
  {
    img: ibnorca,
    title: "Cumplimiento de la norma: NB/ISO 14064-1:2020 - ISO 14064-1:2018",
    description:
      "El Instituto Boliviano de Normalización y Calidad (IBNORCA) ha verificado que el INSTITTUTO DE INVESTIGACIONES INDUSTRIALES - IIIFI cumple con los requisitos de la norma NB/ISO 14064-1:2020 - ISO 14064-1:2018 para la cuantificación y reporte de gases de efecto invernadero (GEI) a nivel organizacional.",
    width: "35%",
  },
  {
    img: impacta,
    title: "Programa de Negocios Competitivos Global Reporting Initiative GRI",
    description:
      "El IIIFI es la entidad representativa de la UMSA, que se ha integrado a este proceso, que tiene por objeto la mejora continua de capacidades, para que, a través de generar servicios competitivos y acceder a nuevas oportunidades con aliados estratégicos, en el proceso de gestión de la I+D+i.",
    width: "60%",
  },
  {
    img: icontec,
    title: "CERTIFICACIÓN ISO 9001:2015",
    description:
      "De los procesos de Gestión Administrativa para los Proyectos de Investigación y Programas Posgraduales del Instituto de Investigaciones Industriales - IIIFI.",
    width: "40%",
  },
];

function QuienesSomos() {
  return (
    <>
      <Grid container spacing={4}>
        <Grid item size={12}>
          <AnimatedSection direction="right">
            <Typography variant="h2" align="center">
              <strong>¿Quiénes Somos?</strong>
            </Typography>
          </AnimatedSection>
        </Grid>
        <Grid
          item
          size={12}
          sx={{
            backgroundImage: `url(${reseña})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            color: "white",
            padding: 4,
            borderRadius: 2,
            boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
          }}
        >
          <AnimatedSection>
            <Stack spacing={1}>
              <Typography variant="h4" align="left">
                <strong>Reseña Histórica del IIIFI</strong>
              </Typography>
              <Typography variant="body1" align="justify" sx={{ px: 4 }}>
                La autonomía universitaria fue declarada el 29 de junio de 1930
                durante la presidencia de Carlos Blanco Galindo, designándose al
                Dr. Juan Francisco Bedregal como Rector y al Ing. Vicente
                Burgaleta como Decano. En esa época, la Facultad funcionaba en
                los pisos superiores del edificio de la Av. Villazón. <br />
                <br />
                En 1943, gracias a la visión del Ing. Vicente Burgaleta y Pérez
                de Alborada, se fundó la Escuela de Ingeniería Industrial, con
                un plan de estudios orientado a la mecánica, la economía y la
                física industrial. Con el paso del tiempo, esta Escuela se
                consolidó como una de las principales unidades académicas de la
                UMSA. Durante las décadas siguientes, las carreras de Ingeniería
                Civil e Industrial evolucionaron y, en 1972, fueron reunidas
                bajo la Facultad de Tecnología. <br />
                <br />
                Finalmente, en 1984, se conformó la actual Facultad de
                Ingeniería, integrando ocho carreras. En 1989-1990, la Carrera
                de Ingeniería Industrial tomó la decisión de crear el Instituto
                de Investigaciones Industriales (IIIFI) con el objetivo de
                fortalecer el desarrollo tecnológico nacional, promover la
                investigación aplicada y vincular el conocimiento académico con
                el sector productivo del país. <br />
                <br />
                El 18 de junio de 1991, mediante Resolución HCU N° 85/91, se
                oficializó la creación del IIIFI, estableciendo sus funciones en
                cuatro áreas fundamentales:{" "}
                <strong>
                  Investigación aplicada, Desarrollo industrial, Capacitación de
                  recursos humanos, Servicios industriales. <br />
                </strong>
                <br />
                Actualmente, el IIIFI continúa su labor comprometido con la
                innovación, la formación y el fortalecimiento del sector
                industrial boliviano, en el marco de la planificación
                estratégica de la Universidad Mayor de San Andrés y del Sistema
                de la Universidad Boliviana.
              </Typography>
            </Stack>
          </AnimatedSection>
        </Grid>
        <Grid item size={12}>
          <Divider />
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }}>
          <AnimatedSection>
            <Stack spacing={2} sx={{ px: 2 }}>
              <ImageCard img={mision} width={"80%"} />
              <Typography variant="h5" align="center">
                <strong>Misión</strong>
              </Typography>
            </Stack>
          </AnimatedSection>
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }}>
          <AnimatedSection>
            <Stack spacing={2} sx={{ px: 2 }}>
              <ImageCard img={vision} width={"80%"} />
              <Typography variant="h5" align="center">
                <strong>Visión</strong>
              </Typography>
            </Stack>
          </AnimatedSection>
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }}>
          <AnimatedSection>
            <Stack spacing={2} sx={{ px: 2 }}>
              <ImageCard img={politicaCalidad} width={"80%"} />
              <Typography variant="h5" align="center">
                <strong>Política de Calidad</strong>
              </Typography>
            </Stack>
          </AnimatedSection>
        </Grid>
        <Grid item size={12}>
          <Divider />
        </Grid>
        <Grid item size={12}>
          <Typography variant="h4" align="center">
            <strong>
              Certificaciones de Calidad del Instituto de Investigaciones
              Industriales
            </strong>
          </Typography>
        </Grid>
        {imagenesCertificaciones.map((cert, idx) => (
          <Grid alignSelf={"center"} item size={{ xs: 12, md: 4 }} key={idx}>
            <AnimatedSection>
              <Stack spacing={2} sx={{ px: 2 }}>
                <ImageCard img={cert.img} width={cert.width} />
                <Typography variant="h6" align="center">
                  <strong>{cert.title}</strong>
                </Typography>
                <Typography variant="body2" align="justify">
                  {cert.description}
                </Typography>
              </Stack>
            </AnimatedSection>
          </Grid>
        ))}
        <Grid item size={12}>
          <Divider />
        </Grid>
        <Grid item size={12} sx={{ backgroundColor: "white", borderRadius: 2 }}>
          <Typography variant="h4" align="center">
            <strong>
              Director del Instituto de Investigaciones Industriales
            </strong>
          </Typography>
          <Typography variant="h5" align="center">
            <strong>Ing. Miguel Yucra Rojas Ph.D</strong>
          </Typography>
          <Grid
            justifyContent={"center"}
            container
            spacing={2}
            sx={{ mt: 2, mb: 4 }}
          >
            <Grid
              item
              size={{ xs: 12, md: 4 }}
              alignContent={"center"}
              justifyContent={"center"}
            >
              <AnimatedSection>
                <img
                  src={director}
                  alt="Director"
                  // height="100%"
                  width="100%"
                />
              </AnimatedSection>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
                md: 8,
              }}
            >
              <AnimatedSection>
                <Stack
                  spacing={2}
                  sx={{
                    backgroundImage: `url(${directorBackground})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <Typography variant="h6" align="center">
                    <strong>Formación Académica</strong>
                  </Typography>
                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <SchoolIcon />
                      </ListItemIcon>
                      <ListItemText primary="Ingeniero Industrial – UMSA, 1987." />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <SchoolIcon />
                      </ListItemIcon>
                      <ListItemText primary="Doctor Ph.D. en Gestión de Investigación – Universidad Mayor de San Andres,2015." />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <SchoolIcon />
                      </ListItemIcon>
                      <ListItemText primary=" Magister en Desarrollo Sustentable - Universidad Nur, 2006." />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <SchoolIcon />
                      </ListItemIcon>
                      <ListItemText primary="Diplomado en Gobernabilidad y Gerencia Política UNIVALLE, 2006." />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <SchoolIcon />
                      </ListItemIcon>
                      <ListItemText primary=" Diplomado en Metodología de Investigación, UMSA, 2009" />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <SchoolIcon />
                      </ListItemIcon>
                      <ListItemText primary="Diplomado en Desarrollo Humano en la Gestión Universitaria." />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <SchoolIcon />
                      </ListItemIcon>
                      <ListItemText primary="Especialización en gerencia de Proyectos, IDEA, 2001." />
                    </ListItem>
                  </List>
                  <Divider />
                  <Typography variant="h6" align="center">
                    <strong>Experiencia</strong>
                  </Typography>
                  <Typography variant="body1" align="justify" sx={{ px: 4 }}>
                    30 años de experiencia profesional en diferentes
                    instituciones del Sector Público (Ministerio de Industria y
                    Comercio Interno, Empresa Transnaval, Ministerio de
                    Educación, entre otros) Privado (Empresa Industrial América
                    Textil, Ingenio Azucarero de Bermejo) Cooperación
                    Internacional (Consultor en el PNUD, OIT en áreas de
                    Desarrollo económico en Africa, Centroamérica)
                    <br />
                    Docente titular con 11 años de experiencia docente en las
                    Facultades de Ingeniería, Carrera de Ingeniería Industrial y
                    Facultad de Tecnología, Carrera de Quimica Industrial, de la
                    UMSA.
                    <br />
                    Director Interino del Instituto de Investigaciones
                    Industriales de la UMSA, 2011-2012
                    <br />
                    Docente Investigador Titular del Instituto de
                    Investigaciones Industriales de la UMSA, desde el 2008 a la
                    fecha
                    <br />
                    Cooordinador en cuatro proyectos desarrollados por el
                    Instituto de Investigaciones Industriales, con recursos
                    concursables mediante fondos IDH
                    <br />
                  </Typography>

                  {/* <Typography variant="h6" align="center">
                  <strong>Producción Intelectual</strong>
                </Typography>
                <Typography variant="body1" align="justify">
                  Terán-Mita, T.A. 2023. Aplicación de indicadores ambientales
                  de eficiencia en el marco de la circularidad: Una aproximación
                  al Sector Productivo Industrial de los Municipios de La Paz y
                  El Alto. Revista Industrial 4.0. V6. UMSA.
                  <br />
                  Terán-Mita, T.A. 2021. Diagnóstico de la Circularidad y
                  Gestión de Residuos en el Sector Industrial. Revista
                  Industrial 4.0. V2. UMSA.
                  <br />
                  Terán-Mita, T.A., Maldonado, C. 2020. Potencialidades de
                  aprovechamiento de residuos en el marco de la Economía
                  Circular. Revista Industrial 4.0. V1. UMSA.
                  <br />
                  Terán-Mita, T.A., Faz, A., Salvador, F., Arocena, J.M.,
                  Acosta, J.A., 2013. High altitude artisanal small-scale gold
                  mines are hot spots for Mercury in soils and plants.
                  Environmental Pollution. 173, 103–109. ISBN: 0269-7491. DOI:
                  10.1016/j.envpol.2012.10.008
                  <br />
                  Acosta, J.A., Martinez-Martinez, S., Faz, A., Millán, R.,
                  Muñóz, M.A., Terán-Mita, T.A., Vera R. 2011. Characterization
                  of the Potential Mercury Contamination in the Apolobamba Gold
                  Mining Area, Bolivia. Spanish Journal of Soil Science. DOI:
                  10.3232/SJSS.2011.V1.N1.06
                  <br />
                  Terán-Mita, T.A., Faz, A., Muñóz, M.A., Acosta, J.A.,
                  Martinez-Martinez, S., Millán, R.2009. Metal Pollution by
                  Mining Activities in Sunchulli Mining district of Apolobamba
                  (Bolivia). Springer Dordrecht Heidelberg. Bary, Italy. ISBN
                  -10: 9048186560.
                  <br />
                </Typography> */}
                </Stack>
              </AnimatedSection>
            </Grid>
          </Grid>
        </Grid>
        <Grid item size={12}>
          <Divider />
        </Grid>
        <Grid item size={12}>
          <Typography variant="h4" align="center">
            <strong>Investigadores </strong>
          </Typography>
        </Grid>
        <Grid item size={12}>
          <AnimatedSection>
            <Slider {...carouselSettings}>
              <Stack spacing={2} sx={{ px: 2 }}>
                <ImageCard img={dLino} width={"40%"} />
              </Stack>
              <Stack spacing={2} sx={{ px: 2 }}>
                <ImageCard img={dVelasco} width={"40%"} />
              </Stack>
              <Stack spacing={2} sx={{ px: 2 }}>
                <ImageCard img={dLuque} width={"40%"} />
              </Stack>
              <Stack spacing={2} sx={{ px: 2 }}>
                <ImageCard img={dDanitza} width={"40%"} />
              </Stack>
              <Stack spacing={2} sx={{ px: 2 }}>
                <ImageCard img={dTeran} width={"40%"} />
              </Stack>
            </Slider>
          </AnimatedSection>
        </Grid>
        <Grid item size={12}>
          <Divider />
        </Grid>
      </Grid>
    </>
  );
}

export default QuienesSomos;
